import { batch } from 'react-redux'

import { ACTION_TYPES, DIALOGS, TABS, THEMES } from '~/core/constants'
import { getIsNarrowLayout } from '~/selectors/ui'
import store from '~/core/store'
import analytics from '~/services/analytics'
import { setApplicationTheme, getApplicationTheme } from '../core/ui'

const { UI } = ACTION_TYPES

export const setViewedSession = sessionId => ({
  type: UI.SET_VIEWED_SESSION,
  payload: sessionId
})

export const setTheme = theme => ({
  type: UI.SET_THEME,
  payload: theme
})

export const setMeetingsTab = tab => ({
  type: UI.SET_MEETINGS_TAB,
  payload: tab
})

export const setWindowSize = size => ({
  type: UI.SET_WINDOW_SIZE,
  payload: size
})

export const addVisibleScreen = screen => ({
  type: UI.ADD_VISIBLE_SCREEN,
  payload: screen
})

export const removeVisibleScreen = screen => ({
  type: UI.REMOVE_VISIBLE_SCREEN,
  payload: screen
})

export const setLayoutType = layoutType => ({
  type: UI.SET_LAYOUT_TYPE,
  payload: layoutType
})

export const setFullScreenState = value => ({
  type: UI.SET_FULL_SCREEN,
  payload: value
})

export const setShowUpcomingPanel = value => ({
  type: UI.SET_SHOW_UPCOMING_PANEL,
  payload: value
})

export const navigateToSessionDetails = sessionId => async dispatch => {
  dispatch(setViewedSession(sessionId))
}

export const closeSessionDetails = () => (dispatch, getState) => {
  const isNarrowLayout = getIsNarrowLayout(getState())

  batch(() => {
    if (isNarrowLayout) {
      dispatch(setMeetingsTab(TABS.RECENT))
    }

    dispatch(setViewedSession(null))
  })
}

export const setDialog = (dialog, props = {}) => ({
  type: UI.SET_DIALOG,
  payload: {
    dialog,
    props
  }
})

export const hideDialog = () => {
  store.dispatch(setDialog(DIALOGS.NONE))
}

export const setJoinButtonDisabled = isDisabled => ({
  type: UI.SET_JOIN_BUTTON_DISABLED,
  payload: isDisabled
})

export const setRoomInputError = hasError => {
  if (hasError) {
    analytics.trackJoinMeeting(
      analytics.EVENT_STATES.FAIL,
      {
        origin: analytics.JOIN_MEETING_ORIGINS.JOIN_BY_ID,
        reason: 'Wrong meeting name'
      }
    )
  }

  return {
    type: UI.SET_ROOM_INPUT_ERROR,
    payload: hasError
  }
}

export const showLinkDialog = () => dispatch =>
  dispatch(setDialog(DIALOGS.LINK))

const getTheme = () => async dispatch => {
  const defaultTheme = THEMES.LIGHT
  const theme = await getApplicationTheme(defaultTheme)
  dispatch(setTheme(theme))
}

export const updateTheme = theme => {
  setApplicationTheme(theme)
  return setTheme(theme)
}

export const initTheme = theme => dispatch => {
  if (theme) {
    dispatch(setTheme(theme))
  } else {
    dispatch(getTheme())
  }
}
